module.exports = __webpack_public_path__ + "static/tastytrade-aus-privacy-policy-bd5b1a5a55d49ab08dd03a490767c279.pdf";